import React, { useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { Container, Typography, Box, Alert } from '@mui/material';
import {register} from "../services/api";
import RegisterForm from "../components/RegisterForm";

const Register: React.FC = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    const handleRegister = async (data: { email: string; password: string }) => {


        try {
            setError(null);
            const response = await register(data.email, data.password);

            console.log('Registration successful:', response.data);
            navigate('/login'); // Перенаправление на страницу входа после успешной регистрации
        } catch (error) {
            console.error('Registration error:', error);
            setError('Failed to register. Please try again.');
        }
    };

    return (
        <Box sx={{display: 'flex', height: '100vh'}}>
            {/* Левая часть с фоновым изображением */}
            <Box
                sx={{
                    margin: '4px',
                    borderRadius: '12px',
                    flex: 1,
                    backgroundImage: 'url(https://static.productscript.ru/uploads/images/pattern.jpg)',
                    backgroundSize: 'cover'
                }}
            />
            <Container component="main" maxWidth="xs">
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '100vh'
                }}>
                    <Box sx={{mt: 6}}>
                        <img src="/logo.svg" className='startLogo' alt=""/>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography component="h1" variant="h5">
                            Регистрация
                        </Typography>
                        {error && <Alert severity="error">{error}</Alert>}
                        <RegisterForm onSubmit={handleRegister} buttonText="Sign In" />
                        <Link to="/login">Войти</Link>
                    </Box>
                    <Box sx={{
                        mb: 4,
                        mt: 5,
                        display: 'block',
                        justifyContent: 'space-between',
                        width: '100%',
                        textAlign: 'center',
                        color: '#888'
                    }}>
                        2024
                    </Box>

                </Box>
            </Container>
        </Box>

    );
};

export default Register;